export default function getFormattedDuration(duration: string): string {
  const parts = duration.split(':').map(Number)

  let hours = 0
  let minutes = 0
  let seconds = 0

  if (parts.length === 2) {
    // Format: MM:SS
    [minutes, seconds] = parts
  } else if (parts.length === 3) {
    // Format: HH:MM:SS
    [hours, minutes, seconds] = parts
  }

  let result = ''

  if (hours > 0) {
    result += `${hours}h`
    result += `${String(minutes).padStart(2, '0')}min`
    result += `${String(seconds).padStart(2, '0')}s`
  } else if (minutes > 0) {
    result += `${minutes}min`
    result += `${String(seconds).padStart(2, '0')}s`
  } else {
    result += `${seconds}s`
  }

  return result
}
